// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_g8-0";
export var headerCellHover = "_g8-1";
export var readCellContainer = "_g8-2";
export var searchHighlight = "_g8-4";
export var unreadIndicator = "_g8-3";